import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ gfm: true, breaks: false });

/* Markdown (article body) -> sanitized HTML for inline rendering.
   Also safely handles plain text and lightly-embedded HTML. */
export function renderMarkdown(input) {
  if (!input) return "";
  const html = marked.parse(String(input), { async: false });
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ["target", "rel", "loading"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i
  });
}
